<template>
  <div class="page-header page-header-light">
    <div class="page-header-content header-elements-md-inline">
      <div class="page-title d-flex">
        <h4>
          <i
            class="icon-arrow-left52 mr-2 pointer-cursor"
            @click="backToPrevPage"
          />
          <span class="font-weight-semibold">{{ $t(`_BackofficeMenu.${title}`) }}</span>
        </h4>
        <a
          href="#"
          class="header-elements-toggle text-default d-md-none"
        >
          <i class="icon-more" />
        </a>
      </div>
    </div>

    <div class="breadcrumb-line breadcrumb-line-light header-elements-md-inline">
      <div class="d-flex">
        <div class="breadcrumb">
          <router-link
            to="/"
            class="breadcrumb-item"
          >
            <i class="fas fa-home mr-2" />
            <span>{{ $t("_BackofficeMenu.Home") }}</span>
          </router-link>
          <router-link
            :to="breadcrumbList.link"
            class="breadcrumb-item"
          >
            <!-- <i
              class="mr-2"
              :class="breadcrumbList.icon"
            /> -->
            {{ $t(`_BackofficeMenu.${breadcrumbList.title}`) }}
          </router-link>
        </div>
        <a
          href="#"
          class="header-elements-toggle text-default d-md-none"
        >
          <i class="icon-more" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderContent",
  data() {
    return {
      title: "",
      item: this.$route,
      breadcrumbList: [],
      icon: "",
    };
  },
  created() {},
  components: {},
  watch: {
    $route(newRoute) {
      this.showTitle();
      this.updateList();
    },
  },
  computed: {},
  methods: {
    showTitle() {
      let suffix = this.$route.meta.suffix;
      if (suffix === undefined) {
        suffix = "";
      } else {
        suffix = " " + this.$t(suffix);
      }
      this.title = this.$route.meta.title;
      document.title = this.$t(this.$route.meta.title) + suffix;
    },
    updateList() {
      this.breadcrumbList = this.$route.meta;
      console.log("breadcrumbList: ", this.$route, this.$route.meta, this.breadcrumbList)
    },
    documentClick(e) {},
    backToPrevPage() {
      const [last] = this.breadcrumbList;
      if (last.link !== undefined) {
        this.$router.push(last.link);
      } else {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    this.updateList();
    this.showTitle();
  },
};
</script>

<style scoped>
.pointer-cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/backoffice/layout/template/HeaderContent.vue